import { render, staticRenderFns } from "./coaching_flagged.vue?vue&type=template&id=76bd6ac8&scoped=true&"
import script from "./coaching_flagged.vue?vue&type=script&lang=js&"
export * from "./coaching_flagged.vue?vue&type=script&lang=js&"
import style0 from "./coaching_flagged.vue?vue&type=style&index=0&id=76bd6ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bd6ac8",
  null
  
)

export default component.exports